<template>
    <Search :searchArr="category" @setState="setState" :boardId="board.boardId"/>
    <!-- <div class="board__search">
        <div class="select">
            <a href="javascript:;" class="select--btn" :class="{ active: select01 }"  @click.prevent="activeselect01">KOR</a>
            <slide-up-down :active="select01" class="select-option">
                <a href="" class="select-option--btn">KOR</a>
                <a href="" class="select-option--btn">ENG</a>
            </slide-up-down>
        </div>
        <div class="board__search__box">
            <input type="text" placeholder="검색어를 입력해주세요">
            <button></button>
        </div>
    </div> -->
    <ul class="qna-list arabic lang">
        <li class="qna-item" :class="{ active: activeIndex === index }" v-for="(article, index) in list" :key="index">
            <a class="qna-item__btn" href="javascript:;" @click.prevent="toggleAnswer(index)">
                <h4 class="qna-item--icon">Q</h4>
                <h4 class="qna-item__btn--text"><span class="category"  v-if="article.category">[{{article.category}}]</span>{{ article.title }}</h4>
            </a>
            <slide-up-down :active="activeIndex === index">
                <div class="qna-item__cont">
                    <h4 class="qna-item--icon">A</h4>
                    <p class="qna-item--text" v-html="article.content"></p>
                </div>
            </slide-up-down>
            <a href="javascript:;" class="qna-item__btn-mo show-mo" @click.prevent="toggleAnswer(index)"></a>
        </li>
    </ul>
    <kr_Pagination :totCnt="totCnt" :pageRow="pageRow" :currentNum="currentNum" :pageCount="pageCount" @setNum="setNum"/>
</template>

<script>
import SlideUpDown from 'vue-slide-up-down';
import Search from '../common/SearchBox.vue'

export default {
    props: {
        boardInfo: null
    },
    components: {
        SlideUpDown,
        Search,
    },
    data() {
        return {
            activeIndex: null,  
            select01: false,

            category: [],
            board: {},
            list: '',
            pageList: '',
            // pageCount: window.innerWidth > 720 ? 10 : 5,
            pageCount: 5,
            totCnt: 0,

            // 게시글 parameter
            currentNum: this.$route.query.currentNum || 1,
            pageRow: 10,
            //검색 관련 parameter
            title: this.$route.query.title || '',
            content: this.$route.query.content || '',
            searchKeyword: this.$route.query.searchKeyword || '',
            searchCategory: this.$route.query.searchCategory || '',
        };
    },
    watch: {
        $route(to, from) {
            // 동일 게시판 안에서 이동
            if (to.query != from.query && to.path == from.path) {
                if (Object.keys(to.query).length === 0) this.init()
                for (let i in this.$route.query) {
                    this[i] = this.$route.query[i]
                }

                this.getList()
            }
        },
        // 다른 게시판으로 이동
        boardInfo(oldVal, newVal) {
            this.init()
            this.getList()
        }
    },
    methods: {
        // 선택된 항목의 인덱스를 토글
        toggleAnswer(index) {
            if (this.activeIndex === index) {
                this.activeIndex = null;  
            } else {
                this.activeIndex = index;
                setTimeout(() => {
                    let table = document.querySelector('.qna-item.active .table table');
                    console.log(table);
                    if(table){
                        if (table && table.offsetWidth > table.parentElement.offsetWidth) {
                            table.parentElement.classList.add('scroll');
                        } else {
                            table.parentElement.classList.remove('scroll');
                        }  
                    }
                }, 0);
            }
        },
        activeselect01() {
            this.select01 = !this.select01;
        },
        getList() {
            const boardNo = this.boardInfo.boardNo
            const params = {
                hospId: this.$store.getters.getHost,
                boardNo: boardNo,
                startIndex: this.currentNum,
                pageRow: this.pageRow,
                title: this.title,
                content: this.content,
                searchKeyword: this.searchKeyword,
                category: this.searchCategory
            }
            this.axios.get(this.api.article.list + boardNo, {
                params: params
            })
                .then(res => {
                    this.list = res.data.list
                    this.board = res.data.board
                    this.totCnt = res.data.totCnt

                    this.category = []

                    this.category.push({title: '전체', value: ''})
                    for(let i of res.data.board.boardCategory.split(',')) {
                        this.category.push({title: i, value: i})
                    }

                })
        },
        // 검색 emit
        setState(s, v, p) {
            this.searchCategory = p
            this.currentNum = 1
            this[s] = v
            this.goPage()
        },
        // pagination emit
        setNum(n) {
            this.currentNum = n
            this.goPage()
        },
        goPage() {
            const obj = { currentNum: this.currentNum, title: this.title, content: this.content, searchKeyword: this.searchKeyword, searchCategory: this.searchCategory };
            for (const key in obj) {
                if (obj[key] === null || obj[key] === '') {
                    delete obj[key];
                }
            }

            this.$router.push({ path: this.$route.path, query: obj });
        },
        // 데이터 초기화
        init() {
            this.currentNum = 1
            this.title = ''
            this.content = ''
            this.searchKeyword = ''
        }
    },
    mounted() {
        this.getList()
    },
}
</script>

<style scoped>
</style>
